import { render } from "./SecondaryInfoModal.vue?vue&type=template&id=8d0ba92c&scoped=true"
import script from "./SecondaryInfoModal.vue?vue&type=script&lang=js"
export * from "./SecondaryInfoModal.vue?vue&type=script&lang=js"

import "./SecondaryInfoModal.vue?vue&type=style&index=0&id=8d0ba92c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0ba92c"]])

export default __exports__